export class Categoria {
    id: number;
    nombre: string;
    idIdioma: number;
    filled:boolean;
}